import { render } from "./shareDynamic.vue?vue&type=template&id=20d81dae&scoped=true"
import script from "./shareDynamic.vue?vue&type=script&lang=js"
export * from "./shareDynamic.vue?vue&type=script&lang=js"

import "./shareDynamic.vue?vue&type=style&index=0&id=20d81dae&scoped=true&lang=css"
import "./shareDynamic.vue?vue&type=style&index=1&id=20d81dae&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d81dae"]])

export default __exports__